import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Slider.module.scss";
/**
 * Thin range slider built on a native `<input type="range">` — keyboard,
 * focus and drag come for free. The track is a fixed gradient bar; progress
 * is conveyed by the thumb position.
 */
export const Slider = ({ value, max = 100, onChange, className, ...rest }) => (_jsx("input", { type: "range", min: 0, max: max, step: "any", value: value, onChange: (e) => onChange(Number(e.target.value)), className: cn(styles.slider, className), ...rest }));
